import { Component, Input } from '@angular/core';
import { PageCreationApproval } from '../../../../shared/models/required-actions/page-creation-approval';

@Component({
  selector: 'app-page-creation-approval',
  templateUrl: './page-creation-approval.component.html',
  styleUrls: ['./page-creation-approval.component.css']
})
export class PageCreationApprovalComponent {
  @Input() requiredAction: PageCreationApproval;
}
